// extracted by mini-css-extract-plugin
module.exports = {"container":"OfflineOrderDetailsCheckoutButton_container__2nU5R"};